/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */

// Load the routes for the specific country.
const routes = require(`../../config/client.routes.json`);

const getClientRoutes = () => {
  return routes;
};

export default getClientRoutes;
